import React, { Fragment } from "react";

export default (
  <>
    <path d="M18.1 23.7c.4-.5.4-1.2 0-1.7L8.3 12l9.8-10c.4-.5.4-1.2 0-1.7s-1.2-.5-1.6 0L5.9 11.2c-.4.5-.4 1.2 0 1.7l.1.1c0-.1 0 0 0 0l10.5 10.7c.4.4 1.2.4 1.6 0z" />
  </>
);
